import { render, staticRenderFns } from "./PinchZoomOverlay.vue?vue&type=template&id=9db2ffa4&scoped=true"
import script from "./PinchZoomOverlay.vue?vue&type=script&lang=js"
export * from "./PinchZoomOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db2ffa4",
  null
  
)

export default component.exports